import { Menu } from "lucide-react";

import { useStore } from "@/lib/store";

type SidebarToggleButtonProps = {
  className?: string;
};

export function SidebarToggleButton({
  className = "inline-flex h-9 w-9 items-center justify-center rounded text-cyber-muted transition-colors hover:bg-cyber-surface/50 hover:text-cyber-cyan md:hidden",
}: SidebarToggleButtonProps): React.JSX.Element {
  const toggleSidebar = useStore((state) => state.toggleSidebar);

  return (
    <button
      type="button"
      onClick={toggleSidebar}
      className={className}
      title="Open navigation"
      aria-label="Open navigation"
    >
      <Menu size={20} />
    </button>
  );
}
